import { useRoutes } from '@folklore/routes';
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch, useLocation } from 'wouter';

import usePage from '../hooks/usePage';

import Layout from './layouts/Layout';
import ErrorPage from './pages/Error';
import EventPage from './pages/Event';
import FilmPage from './pages/Film';
import HomePage from './pages/Home';
import PageLoader from './pages/Loader';
import PersonPage from './pages/Person';
import WeekPage from './pages/Week';
import EmailConfirmed from './pages/auth/EmailConfirmed';
import LoginPage from './pages/auth/Login';
import RequestPage from './pages/auth/Request';
import ResetPage from './pages/auth/Reset';
import SignupPage from './pages/auth/Signup';
import AccountPage from './pages/pro/Account';
import AddressesPage from './pages/pro/Addresses';
import ProEventPage from './pages/pro/Event';
import FavoritesPage from './pages/pro/Favorites';
import FilmsPage from './pages/pro/Films';
import ProHomePage from './pages/pro/Home';
import OrderPage from './pages/pro/Order';
import OrderCreatePage from './pages/pro/OrderCreate';
import OrdersPage from './pages/pro/Orders';
import PaymentPage from './pages/pro/Payment';

import '../../styles/styles.css';

const propTypes = {
    page: PropTypes.shape({}),
    statusCode: PropTypes.number,
};

function Routes({ statusCode = null }) {
    const [pathname] = useLocation();
    const routes = useRoutes() || {};

    const patternsWithoutCache = ['mon-compte', 'account'];
    const {
        page = null,
        loading = false,
        refetch = null,
        status,
        error,
    } = usePage(pathname, { patternsWithoutCache });

    const { type: pageType = null } = page || {};
    const isError = status === 'error' && error !== null && !loading;

    return (
        <Layout page={page} loading={loading} statusCode={statusCode} status={status}>
            <Switch>
                <Route path={routes.home || '/'} exact>
                    {pageType === 'week' ? (
                        <WeekPage page={page} loading={loading} />
                    ) : (
                        <HomePage page={page} loading={loading} />
                    )}
                </Route>
                <Route path={routes['events.show']} exact>
                    <EventPage page={page} loading={loading} />
                </Route>
                <Route path={routes['films.show']} exact>
                    <FilmPage page={page} loading={loading} />
                </Route>
                <Route path={routes['people.show']} exact>
                    <PersonPage page={page} loading={loading} />
                </Route>
                <Route path={routes['pro.home']}>
                    <ProHomePage page={page} loading={loading} />
                </Route>
                <Route path={routes['pro.account']}>
                    <AccountPage page={page} loading={loading} refetch={refetch} />
                </Route>
                <Route path={routes['pro.favorites']}>
                    <FavoritesPage page={page} loading={loading} />
                </Route>
                <Route path={routes['pro.event']}>
                    <ProEventPage page={page} loading={loading} />
                </Route>
                <Route path={routes['pro.orders.create']}>
                    <OrderCreatePage page={page} loading={loading} />
                </Route>
                <Route path={routes['pro.order']}>
                    <OrderPage page={page} loading={loading} />
                </Route>
                <Route path={routes['pro.orders']}>
                    <OrdersPage page={page} loading={loading} />
                </Route>
                <Route path={routes['pro.order.payment']}>
                    <PaymentPage page={page} loading={loading} />
                </Route>
                <Route path={routes['pro.films']}>
                    <FilmsPage page={page} loading={loading} />
                </Route>
                <Route path={routes['pro.addresses']}>
                    <AddressesPage page={page} loading={loading} />
                </Route>
                <Route path={routes.login}>
                    <LoginPage page={page} loading={loading} />
                </Route>
                <Route path={routes.signup}>
                    <SignupPage page={page} loading={loading} />
                </Route>
                <Route path={routes['password.request']}>
                    <RequestPage page={page} loading={loading} />
                </Route>
                <Route path={routes['password.reset']}>
                    <ResetPage page={page} loading={loading} />
                </Route>
                <Route path={routes['email.confirmed']}>
                    <EmailConfirmed page={page} loading={loading} />
                </Route>
                <Route path={routes.page} exact>
                    <PageLoader page={page} loading={loading} error={isError} />
                </Route>
                <Route path="*">
                    <ErrorPage />
                </Route>
            </Switch>
        </Layout>
    );
}

Routes.propTypes = propTypes;

export default Routes;
